import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'kt-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnChanges {
  @Input() backgroundColor: string = '';
  @Input() labelColor: string = '';
  @Input() badgeColor: string = '';
  @Input() iconColor: string = '';
  @Input() iconName: string = '';
  @Input() imageIcon: string = '';
  @Input() label: string = '';
  @Input() badge: string = '';
  @Input() borderRadius: string = 'small';
  @Input() iconSize: string = 'large';
  @Input() height: string = 'large';
  @Input() tooltipContent: string = '';
  @Input() haveLeftPadding: boolean = true;
  @Input() borderColor: string = '';

  containerStyles: Record<string, string>;
  labelStyles: Record<string, string>;
  badgeStyles: Record<string, string>;
  iconStyles: Record<string, string>;

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStyles();
  }

  private updateStyles(): void {
    this.containerStyles = {
      'background-color': this.backgroundColor || 'transparent',
      'border-radius': this.borderRadius === 'small' ? '6px' : this.borderRadius === 'large' ? '16px' : '',
      'height': this.height === 'small' ? '20px' : '24px',
      'padding-left': this.haveLeftPadding ? '8px' : '0px',
      'border': this.borderColor ? `1px solid ${this.borderColor}` : 'none',
    };
    this.labelStyles = {
      'color': this.labelColor || '#18181B',
      'font-weight': this.labelColor ? '500' : '400'
    };
    this.badgeStyles = {
      'background-color': this.badgeColor || '#E4E4E7',
    };
    this.iconStyles = {
      'color': this.iconColor || '#18181B',
    };
  }
}
